import { Path, Pickup } from '@ahamove/icons/map';
import { IndexedPath } from '@ahamove/icons/marker';
import { useMemo } from 'react';

type Props = {
  pointIndex?: number;
  pointType?: string;
};

export default function useAutocompleteIcon({ pointIndex, pointType }: Props) {
  return useMemo(() => {
    if (pointType) {
      return pointType === 'pickup' ? (
        <Pickup width={16} height={16} />
      ) : pointIndex && pointIndex > 0 ? (
        <IndexedPath width={16} height={16} value={pointIndex} />
      ) : (
        <Path width={16} height={16} />
      );
    }

    return null;
  }, [pointType, pointIndex]);
}
